import React, { FC, useContext, useEffect, useState } from "react";
import {  useLocation, useNavigate, useParams } from "react-router-dom";
import Select,{ GroupBase, OptionsOrGroups, PropsValue, SingleValue } from "react-select";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { STATE_UPDATE_PA } from "src/constants/cases";
import { RequestTreatmentNotTreatingApiResponse } from "src/components/modals/requestDateOfTreatment/types";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "src/context/authContext";




const PriorAuthorization: FC = (): JSX.Element => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search); // Parse query params
  const {isManufacturer}=useContext(AuthContext)

  const [cancelReason, setCancelReason] = useState<string>('approved');
  const [patient] = useState((location.state as { patient: string }).patient)
  
  const { showToast, } = useContext(ToastContext);
  const { caseId,prior_auth_id } = useParams();
  const navigate = useNavigate();
  const { setLoader,hideLoader } = useContext(LoaderContext);





  const { loading, data: requestPriorAuthorization, mutate: updatePriorAuthorization, error: priorAuthorizationError } = 
    useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.PRIOR_AUTHORIZATION);

  useEffect(() => {
    if (priorAuthorizationError) {
      hideLoader()
    }
    if (requestPriorAuthorization) {
      hideLoader()
      showToast([`Prior Authorization Saved and Completed`], ToastTypes.SUCCESS);
      isManufacturer ? navigate(`/todos_statistics`) : navigate('/cases',{ replace: true })  ;
      setCancelReason("Cost");
      const { status } = requestPriorAuthorization;
      if (status === 'ok') {
        showToast([`Prior Authorization Saved and Completed`], ToastTypes.SUCCESS);
       isManufacturer ? navigate(`/todos_statistics`) : navigate(`/cases`);      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestPriorAuthorization, priorAuthorizationError]);

  const updatePriorAuthorizationButton = () => {
    const queryParam = {
      status:cancelReason, 
      case_id: caseId, 
      id: prior_auth_id,
      change_note: STATE_UPDATE_PA.find((item) => item.value === cancelReason)?.change_note
    };
    updatePriorAuthorization(queryParam, { id:prior_auth_id});
  }





  const onChangeSelect = (value: SingleValue<string>) => {
    setCancelReason((value as unknown as { value: string; label: string; }).value);
  };

  const getValue = () => {
    const data = STATE_UPDATE_PA.find((option) => option.value === cancelReason);
    if (data) return data as unknown as PropsValue<string>;
  };

    return (
        <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
            <div className="bg-mist py-2">
                <div className="container-fluid">
                    <AuthSubHeader/>
                </div>
            </div>
            <div className="container-fluid pt-2 d-flex flex-column flex-fill">
                <div className="card-header">
                    <h2 className="m-0 page-heading">
                        Update PA Status for Case {caseId}
                        <small>{'(' + patient + ")"}</small>
                    </h2>
                    <p className="fw-bold m-0 fs-5">(Insurance Name: {queryParams.get('insuranceName')})</p>
                    <p> if you've received updated information or wish to cancel your PA, select a
                        status from the dropdown below and the system will update this case for you. </p>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="col-12 col-md-10 mb-3 mb-md-0">
                                <Select
                                    options={STATE_UPDATE_PA as unknown as OptionsOrGroups<string, GroupBase<string>>}
                                    id="updatePA"
                                    isSearchable={false}
                                    noOptionsMessage={() => "Select Option..."}
                                    value={getValue()}
                                    onChange={(value) => onChangeSelect(value)}
                                />
                            </div>

                            <div className="col-12 col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={updatePriorAuthorizationButton}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterText footerType="black"/>
        </div>
    );
};

export default PriorAuthorization;
